import { Banner } from '@loadsmart/loadsmart-ui'
import LSDate, { DATE_FORMAT_MMDDYYYYHHMM } from 'common/Date.helpers'
import {
  GatewayPollError,
  GatewayPollErrorCategory,
} from 'common/types/kraken-core/GatewaySettings'

const CATEGORY_LABELS: Record<GatewayPollErrorCategory, string> = {
  authentication: 'Authentication',
  network: 'Network',
  configuration: 'Configuration',
  sftp_operation_error: 'SFTP operation',
  undetermined: 'Unknown',
}

export interface PollErrorBannerProps {
  error?: GatewayPollError | null
}

const PollErrorBanner = ({ error }: PollErrorBannerProps) => {
  if (!error) return null

  const label = CATEGORY_LABELS[error.category] ?? error.category
  const at = LSDate(error.at)?.format(DATE_FORMAT_MMDDYYYYHHMM)
  const description = at ? `${error.message} (${at})` : error.message

  return (
    <Banner
      variant="danger"
      scale="large"
      title={`Last poll failed — ${label}`}
      description={description}
      dismissible={false}
    />
  )
}

export default PollErrorBanner
